const reverse = (str: string) => Array.prototype.slice.call(str).reverse().join('') as string;
const revSubstring = (str: string, start: number, end?: number) => reverse( str.substring(start, end) )

export function formatPhone(str: string){
  const num = Array.prototype.filter.call(str, (char: string) => /\d/.test(char)).join('');
  const strLength = num.length;

  let countryCode: string;
  let regionCode: string;
  let phoneNumber: string;

  if (strLength < 10) {
    phoneNumber = str;
  } else if (strLength === 10) {
    countryCode = '7';
    regionCode = num.substring(0, 3);
    phoneNumber = `${ num.substring(3, 6) }-${ num.substring(6, 8) }-${ num.substring(8, 10) }`;
  } else {
    const rev = reverse(num);
    countryCode = revSubstring(rev, 10);
    regionCode = revSubstring(rev, 7, 10);
    phoneNumber = `${ revSubstring(rev, 4, 7) }-${ revSubstring(rev, 2, 4) }-${ revSubstring(rev, 0, 2) }`;
  }

  return [
    countryCode ? `+${countryCode}` : '',
    regionCode,
    phoneNumber,
  ].filter(x => !!x).join(' ');

}

export default formatPhone;



// WEBPACK FOOTER //
// ./src/utils/format_phone.ts